import { createFileRoute, Link } from "@tanstack/react-router";
import { PageHeader } from "@/components/app/shell/page-header";
import { Button } from "@/components/ui/button";
import { useFacility } from "@/lib/facility/facility";
import { guardRoute } from "@/lib/policy/route-guard";
import { FacilityPhoneSettings } from "./-components/facility-phone-settings";
import { OneBuildingCard } from "@/components/app/workspace/one-building-card";

export const Route = createFileRoute("/_authenticated/_front-desk/sarah/facility-settings")({
  beforeLoad: ({ context }) => guardRoute(context.me, "sarah-facility-settings"),
  component: FacilitySettings,
});

/** The old address of a building's phone settings; the Phone list is the way in now. */
function FacilitySettings() {
  const { facilityId } = useFacility();
  const back = (
    <Button asChild variant="outline" size="sm">
      <Link to="/sarah/numbers">All numbers</Link>
    </Button>
  );

  if (facilityId === "all") {
    return (
      <>
        <PageHeader title="Phone" actions={back} />
        <OneBuildingCard prompt="Choose a building, or open its number from the Phone list. One number rings exactly one building." />
      </>
    );
  }

  return (
    <>
      <PageHeader
        title="Phone"
        meta="Every clock time below is read in the building's own timezone."
        actions={back}
      />
      <FacilityPhoneSettings facilityId={facilityId} />
    </>
  );
}
